<template>
  <div class="bullet">
      <img class="bullet-icon"
           :src="bulletIcon">
      <div class="bullet-text padding-right-sm ri-bold-body"
           :class="{'checked': checked, 'ri-body':checked}">
        {{ text }}
      </div>
  </div>

</template>

<script>
export default {
  name: 'Bullet',
  props: {
    checked: {
      type: Boolean,
      required: false,
      default: false,
    },
    text: {
      type: String,
      required: true,
    },
  },
  computed: {
    bulletIcon() {
      return this.checked ? '/images/im-on-it-100-days/checkbox_on.svg' : '/images/im-on-it-100-days/checkbox_off.svg';
    },
  },
};

</script>

<style scoped lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';

.bullet {
  width: 100%;
  height: 95px;
  align-items: center;
  background: white;
  display: flex;
  flex-direction: row;

  .bullet-icon {
    width: 43px;
    height: 43px;
  }

  .bullet-text {
    align-items: center;
    display: flex;

    &.checked {
      color: $riseup_green;
    }
  }
}

</style>
